//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
import moment from 'moment'
// import DIC from '@/index/dictionary'

export default {
  props: {

  },
  data: function () {
    let tab = this.$route.query.tab || 'order'
    let beginTime = this.$route.query.beginTime || moment().format('YYYY-MM-DD');
    let endTime = this.$route.query.endTime || moment().format('YYYY-MM-DD');
    return {
      currentTab: tab,
      search: {
        beginTime: beginTime,
        endTime: endTime
      }
    }
  },
  components: {
    PageOrder: () => import('./components/PageOrder/index.vue'),
    PagePorder: () => import('./components/PagePorder/index.vue'),
    PageDealer: () => import('./components/PageDealer/index.vue')
  },
  mounted () {

  },
  methods: {

  }
}
